.loaderCol {
  margin-top: 50px;
  text-align: center;
}

.loaderRow {
  margin: 0;
  padding: 0;
}